'use client';
import React from 'react';
import { createPortal } from 'react-dom';

export default function ThankYouPopup({ searchParams, onClose }) {
  // Process search parameters based on the new structure.
  const sp = searchParams;
  'sp:', sp;
  const contactName = sp.firstName || 'Valued Customer';
  const requestType = sp.request_type;
  // Extract custom field values
  const additionalInterestParam = sp.interested_in;
  const additionalInterests = Array.isArray(additionalInterestParam)
    ? additionalInterestParam
    : additionalInterestParam
      ? [additionalInterestParam]
      : [];

  const enhancementsParam = sp.enhancements;
  const enhancements = Array.isArray(enhancementsParam)
    ? enhancementsParam
    : enhancementsParam
      ? [enhancementsParam]
      : [];

  // Use timeline from the new parameter
  const timeline = sp.timeline || 'Not Specified';

  // Extract vehicle information from the nested vehicle_information object
  const vehicleInfo = sp.vehicle_information || {};
  const autoYear = vehicleInfo.vehicle_year || '';
  const autoMake = vehicleInfo.vehicle_make || '';
  const autoModel = vehicleInfo.vehicle_model || '';
  const vehicleDetails =
    autoYear && autoMake && autoModel
      ? `for ${autoYear} ${autoMake} ${autoModel}`
      : '';

  const handleClose = () => {
    if (onClose) onClose();
    window.location.href = '/';
  };

  return createPortal(
    <div className="fixed inset-0 z-1000 flex items-center justify-center px-4">
      {/* Overlay: clicking closes the popup */}
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={handleClose}
      />
      {/* Modal Content */}
      <div className="relative w-full max-w-xl rounded-lg bg-white p-8 shadow-xl">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 p-2 text-3xl font-bold text-gray-600 hover:text-gray-800"
        >
          &times;
        </button>
        <h1 className="mb-4 text-3xl font-bold text-gray-800">
          Thank you {contactName}!
        </h1>
        <p className="mb-6 text-lg text-gray-700">
          You will receive a{' '}
          {requestType === 'Appointment Request' ? 'call' : 'estimate'} within 1
          hour. We look forward to helping you with your vehicle needs!
        </p>

        <div className="border-t pt-4">
          <h2 className="mb-2 text-xl font-semibold text-gray-800">
            Submission Details {vehicleDetails ? `${vehicleDetails}:` : ':'}
          </h2>
          <p className="text-gray-700">
            <span className="font-medium">Interest:</span>{' '}
            {additionalInterests.length > 0
              ? additionalInterests.join(', ')
              : 'None'}
          </p>
          <p className="text-gray-700">
            <span className="font-medium">Enhancements:</span>{' '}
            {enhancements.length > 0 ? enhancements.join(', ') : 'None'}
          </p>
          <p className="text-gray-700">
            <span className="font-medium">Timeline Preference:</span> {timeline}
          </p>
        </div>
      </div>
    </div>,
    document.body,
  );
}
